import "./Teamdetail.css";
import backArrow from "../../../../images/arrow.png";
import whiteArrow from "../../../../images/white-arrow.png";
import logo from "../../../../components/images/logo.png";
import { useState, useEffect, useMemo } from "react";
import Teamoverview from "../teamoverview/Teamoverview";
import { NavLink, useLocation, useParams, useNavigate } from "react-router-dom";
import Skeleton from "../../../../components/Skeleton";
import { Helmet } from "react-helmet-async";
import Teamsquad from "../teamsquad/Teamsquad";
import Teammatch from "../teammatch/Teammatch";
import Teamstanding from "../teamstandings/Teamstanding";
import Teamnews from "../teamnews/Teamnews";

const Teamdetail = ({ dark, MyBaseUrl }) => {
  const location = useLocation();
  const { searchTeam, matchedTeam } = location.state || {};
  const { id } = useParams();
  const navigate = useNavigate();

  const teamId = useMemo(() => {
    if (!id) return null;

    const last = id.split("-").pop();
    const num = Number(last);

    return Number.isNaN(num) ? null : num;
  }, [id]);

  const { pathname } = useLocation();

  const activeTab = useMemo(() => {
    if (pathname.endsWith("/news")) return "news";
    if (pathname.endsWith("/standings")) return "standings";
    if (pathname.endsWith("/matches")) return "matches";
    if (pathname.endsWith("/squad")) return "squad";
    return "overview";
  }, [pathname]);
  const [myteam, setMyteam] = useState(null);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [loadingPlayers, setLoadingPlayers] = useState(false);
  const [loadingNews, setLoadingNews] = useState(false);
  const [loadingMatches, setLoadingMatches] = useState(false);
  const [loadingStands, setLoadingStands] = useState(false);

  const [players, setPlayers] = useState([]);
  const [matches, setMatches] = useState([]);
  const [News, setNews] = useState([]);
  const [standings, setStandings] = useState([]);

  // useEffect(() => {
  //   if (!teamId || isNaN(teamId)) return;

  //   setSelectedTeam((prev) => ({
  //     ...prev,
  //     api_id: teamId,
  //   }));
  // }, [teamId, setSelectedTeam]);

  useEffect(() => {
    if (!searchTeam || !matchedTeam || !myteam) return;

    console.log("Search Team ID:", myteam?.id);
    console.log("Selected Team API ID:", myteam?.api_id);
    console.log("Matched Team API ID:", matchedTeam?.api_id);

    console.log(
      "Match Validation:",
      searchTeam?.id === matchedTeam?.id &&
        matchedTeam?.api_id === myteam?.api_id,
    );
  }, [searchTeam, myteam, matchedTeam]);

  useEffect(() => {
    if (!teamId || isNaN(teamId)) return;

    const fetchTeam = async () => {
      try {
        setLoading(true);

        const response = await fetch(`${MyBaseUrl}/teams/${teamId}`);
        if (!response.ok) throw new Error("Failed to fetch team");

        const result = await response.json();

        if (result?.status === "success") {
          setMyteam(result?.data || null);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTeam();
  }, [teamId, MyBaseUrl]);

  useEffect(() => {
    if (!teamId) return;

    const fetchMatches = async () => {
      try {
        setLoadingMatches(true);

        const res = await fetch(`${MyBaseUrl}/teams/${teamId}/matches`);
        const data = await res.json();

        setMatches(data?.status === "success" ? data.data || [] : []);
      } catch {
        setMatches([]);
      } finally {
        setLoadingMatches(false);
      }
    };

    fetchMatches();
  }, [teamId, MyBaseUrl]);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        setLoadingNews(true);

        const res = await fetch(`${MyBaseUrl}/team/${teamId}/news`);

        const data = await res.json();

        if (data?.status === "success") {
          setNews(data.data || []);
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoadingNews(false);
      }
    };

    if (teamId) fetchNews();
  }, [teamId, MyBaseUrl]);

  useEffect(() => {
    const fetchPlayers = async () => {
      try {
        setLoadingPlayers(true);

        const res = await fetch(`${MyBaseUrl}/teams/${teamId}/squad`);

        const data = await res.json();
        if (data?.status === "success") {
          const squad = data?.data?.[0]?.players || [];
          setPlayers(Array.isArray(squad) ? squad : []);
        } else {
          setPlayers([]);
        }
      } catch (err) {
        console.log(err);
        setPlayers([]);
      } finally {
        setLoadingPlayers(false);
      }
    };

    if (teamId) fetchPlayers();
  }, [teamId, MyBaseUrl]);

  useEffect(() => {
    const fetchStandings = async () => {
      try {
        setLoadingStands(true);

        const res = await fetch(`${MyBaseUrl}/teams/${teamId}/standings`);

        const data = await res.json();

        if (data?.status === "success") {
          const allStandings =
            data?.data?.flatMap((item) => item?.league?.standings?.[0] || []) ||
            [];

          setStandings(allStandings);
        } else {
          setStandings([]);
        }
      } catch (err) {
        console.log(err);
        setStandings([]);
      } finally {
        setLoadingStands(false);
      }
    };

    if (teamId) fetchStandings();
  }, [teamId]);

  const createSlug = (home, away) =>
    `${home}-vs-${away}`
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w-]+/g, "");
  const [isStickyTop, setIsStickyTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth <= 600) {
        if (window.scrollY >= 98) {
          setIsStickyTop(true);
        } else {
          setIsStickyTop(false);
        }
      } else {
        if (window.scrollY >= 300) {
          setIsStickyTop(true);
        } else {
          setIsStickyTop(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    handleScroll();
    console.log("URL PARAM ID:", id);
    console.log("Search Team ID:", myteam?.id);
    console.log("Selected Team API ID:", teamId);
    console.log("Matched Team API ID:", matchedTeam?.api_id);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (loading || !myteam) {
    return (
      <div className="homer">
        <div className="teamdetailWrapper">
          <Skeleton dark={dark} count={8} />
        </div>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>
          {myteam?.name
            ? `${myteam.name} - Overview, Squad, Matches & News`
            : "Team Details"}
        </title>

        <meta
          name="description"
          content={
            myteam?.name
              ? `Follow ${myteam.name} football team. View squad, live matches, standings, news, and full team stats including ${myteam?.country || ""}.`
              : "Explore football team details including squad, matches, standings and news."
          }
        />

        <meta
          name="keywords"
          content={`${myteam?.name || "football team"}, squad, matches, standings, news, players, fixtures`}
        />

        <meta
          property="og:title"
          content={`${myteam?.name || "Team"} - Football Overview`}
        />
        <meta
          property="og:description"
          content={`Check ${myteam?.name || "this team"} squad, matches, standings and latest news.`}
        />
        <meta
          property="og:image"
          content="https://fadasports.com/static/media/mobilelogo.d0257d49e02d3094cce0.png"
        />
        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content={`${myteam?.name || "Team"} - Football`}
        />
        <meta
          name="twitter:description"
          content={`View ${myteam?.name || "team"} stats, squad and matches.`}
        />
        <meta name="twitter:image" content={myteam?.logo || ""} />
      </Helmet>

      <div className="homer">
        <div className="teamdetailWrapper">
          <NavLink
            to="/teams"
            style={{ textDecoration: "none" }}
            className="ppp">
            <strong
              style={{
                cursor: "pointer",
                backgroundColor: "transparent",
                border: dark ? "none" : "none",
                color: dark ? "white" : "black",
                padding: "5px 10px",
                borderRadius: "5px",
              }}>
              {dark ? (
                <img
                  src={whiteArrow}
                  alt=""
                  className="whitearrow"
                  style={{
                    transform: "rotate(180deg)",
                    scale: "0.7",
                  }}
                />
              ) : (
                <img src={backArrow} alt="" className="blackarrow" />
              )}
            </strong>
          </NavLink>

          <section
            className="section1"
            style={
              dark
                ? { backgroundColor: "#272727ff" }
                : { backgroundColor: "whitesmoke" }
            }>
            <div>
              <img src={myteam?.logo} alt={myteam?.name} />
              <h1 style={dark ? { color: "#fafafaff" } : { color: "#161819" }}>
                {myteam?.name}
              </h1>
            </div>

            <span>
              <strong style={dark ? { color: "#e2e1e1ff" } : {}}>
                Country: {myteam?.country}
              </strong>

              <strong style={dark ? { color: "#e2e1e1ff" } : {}}>
                Stadium: {myteam?.venue_name}
              </strong>
            </span>

            <nav>
              <ul
                style={
                  dark
                    ? {
                        backgroundColor: "#333333ff",
                        color: "#fff",
                        width: isStickyTop ? "108%" : "100%",
                        marginLeft: isStickyTop ? "-4%" : "0",
                        transform: isStickyTop
                          ? "translateX(0%)"
                          : "translateX(0)",
                        borderRadius: isStickyTop ? "0px" : "",
                        transition: "all 0.3s",
                      }
                    : {
                        width: isStickyTop ? "108%" : "100%",
                        marginLeft: isStickyTop ? "-4%" : "0",
                        borderRadius: isStickyTop ? "0px" : "",
                        transition: "all 0.3s",
                      }
                }>
                <li
                  onClick={() => navigate(`/teams/${id}`)}
                  className={activeTab === "overview" ? "myactive" : "navlink"}
                  style={{
                    cursor: "pointer",
                    ...(dark ? { color: "#fafafaff" } : {}),
                  }}>
                  Overview
                </li>

                <li
                  onClick={() => navigate(`/teams/${id}/news`)}
                  className={activeTab === "news" ? "myactive" : "navlink"}
                  style={{
                    cursor: "pointer",
                    ...(dark ? { color: "#fafafaff" } : {}),
                  }}>
                  News
                </li>

                <li
                  onClick={() => navigate(`/teams/${id}/standings`)}
                  className={activeTab === "standings" ? "myactive" : "navlink"}
                  style={{
                    cursor: "pointer",
                    ...(dark ? { color: "#fafafaff" } : {}),
                  }}>
                  Standings
                </li>

                <li
                  onClick={() => navigate(`/teams/${id}/matches`)}
                  className={activeTab === "matches" ? "myactive" : "navlink"}
                  style={{
                    cursor: "pointer",
                    ...(dark ? { color: "#fafafaff" } : {}),
                  }}>
                  Matches
                </li>

                <li
                  onClick={() => navigate(`/teams/${id}/squad`)}
                  className={activeTab === "squad" ? "myactive" : "navlink"}
                  style={{
                    cursor: "pointer",
                    ...(dark ? { color: "#fafafaff" } : {}),
                  }}>
                  Squad
                </li>
              </ul>
            </nav>
          </section>

          {activeTab === "overview" && (
            <>
              <section className="section2">
                <h1
                  style={
                    dark ? { color: "#fafafaff" } : { color: "#161819ec" }
                  }>
                  Overview
                </h1>
                <p style={dark ? { color: "#e4e4e4ff" } : { color: "#6E6E6E" }}>
                  Watch your favorite team compete in real-time. Tune in now and
                  experience the thrill of {myteam?.country} football - live,
                  Watch your favorite team compete in real-time. The tournament
                  is played in a cup format, featuring a group stage followed by
                  knockout rounds that culminate in the final match where the
                  champion is crowned.
                </p>
              </section>

              <section className="matchsection">
                <section className="myfirstsection">
                  {loadingMatches && (
                    // <h3 style={{ color: dark ? "#fff" : "#111" }}>
                    //   Loading matches...
                    // </h3>
                    <Skeleton dark={dark} count={6} />
                  )}

                  {Array.isArray(matches) && matches.length > 0 ? (
                    <h1
                      style={
                        dark ? { color: "#fafafa" } : { color: "#161819" }
                      }>
                      Team matches
                      <NavLink
                        to="matches"
                        style={{ textDecoration: "none" }}
                        className={({ isActive }) =>
                          isActive ? "active" : "navlink"
                        }>
                        {dark ? (
                          <img
                            src={whiteArrow}
                            alt=""
                            className="whitearrow to"
                            style={{
                              scale: "0.6",
                            }}
                          />
                        ) : (
                          <img
                            src={backArrow}
                            alt=""
                            className="blackarrow to"
                            style={{
                              scale: "1.2",
                              transform: "rotate(180deg)",
                            }}
                          />
                        )}
                      </NavLink>
                    </h1>
                  ) : (
                    <p></p>
                  )}
                  {matches?.slice(0, 3).map((match, index) => {
                    const date = new Date(match?.fixture?.date);

                    const matchTime = date.toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    });

                    const matchDate = date.toLocaleDateString();

                    const status = match?.fixture?.status?.short;

                    const matchId = match?.fixture?.id;
                    const homeTeam = match?.teams?.home;
                    const awayTeam = match?.teams?.away;
                    const goals = match?.goals;

                    return (
                      <div key={match?.fixture?.id || index}>
                        <h2
                          style={
                            dark
                              ? { color: "#fafafaff" }
                              : { color: "#161819ec" }
                          }>
                          {match?.league?.name} ({match?.league?.round})
                        </h2>

                        <small style={dark ? { color: "#d1d1d1ff" } : {}}>
                          {matchDate} {matchTime} GMT
                        </small>

                        <div
                          key={matchId || index}
                          className="matchtable"
                          style={
                            dark
                              ? {
                                  backgroundColor: "#333333ff",
                                  boxShadow: "none",
                                }
                              : {}
                          }>
                          <span
                            className={
                              match?.fixture?.status?.elapsed > 0 &&
                              match?.fixture?.status?.elapsed < 90 &&
                              match?.fixture?.status?.short !== "FT"
                                ? "live-time myspan"
                                : "myspan"
                            }
                            style={
                              match?.fixture?.status?.elapsed > 0 &&
                              match?.fixture?.status?.elapsed < 90 &&
                              match?.fixture?.status?.short !== "FT"
                                ? {}
                                : dark
                                  ? { color: "#dfdfdfff" }
                                  : { color: "#3e3f3f" }
                            }>
                            {match?.score?.penalty?.home !== null ||
                            match?.score?.penalty?.away !== null
                              ? "PK"
                              : match?.score?.extratime?.home !== null ||
                                  match?.score?.extratime?.away !== null
                                ? "Extra"
                                : match?.fixture?.status?.short === "FT" ||
                                    match?.fixture?.status?.elapsed >= 90
                                  ? "FT"
                                  : match?.fixture?.status?.elapsed
                                    ? `${
                                        match.fixture.status.elapsed >= 90 &&
                                        match.fixture.status.extra
                                          ? `${match.fixture.status.elapsed}<sup>+${match.fixture.status.extra}</sup>`
                                          : match.fixture.status.elapsed
                                      }'`
                                    : match?.fixture?.status?.short === "NS"
                                      ? new Date(
                                          match?.fixture?.date,
                                        ).toLocaleTimeString([], {
                                          hour: "2-digit",
                                          minute: "2-digit",
                                          hour12: false,
                                        })
                                      : match?.fixture?.status?.short}
                          </span>

                          <NavLink
                            key={match.fixture.id}
                            to={`/matches/${createSlug(
                              match.teams.home.name,
                              match.teams.away.name,
                            )}/${match.fixture.id}`}
                            state={{ matchId }}
                            style={{ width: "100%" }}>
                            <span
                              className="matchspam"
                              style={{ backgroundColor: "transparent" }}>
                              <nav style={{ backgroundColor: "transparent" }}>
                                <wrap className="MM">
                                  <img
                                    src={homeTeam?.logo}
                                    width="25"
                                    alt={homeTeam?.name}
                                  />
                                  <p
                                    style={
                                      dark
                                        ? { color: "#dbdbdbff" }
                                        : { color: "#161819" }
                                    }>
                                    {homeTeam?.name}
                                  </p>
                                </wrap>

                                <wrap className="NN">
                                  <strong
                                    style={
                                      dark
                                        ? { color: "#dbdbdbff" }
                                        : { color: "#161819" }
                                    }>
                                    {goals?.home}
                                  </strong>
                                </wrap>
                              </nav>

                              <nav style={{ backgroundColor: "transparent" }}>
                                <wrap className="MM">
                                  <img
                                    src={awayTeam?.logo}
                                    width="25"
                                    alt={awayTeam?.name}
                                  />
                                  <p
                                    style={
                                      dark
                                        ? { color: "#dbdbdbff" }
                                        : { color: "#161819" }
                                    }>
                                    {awayTeam?.name}
                                  </p>
                                </wrap>

                                <wrap className="NN">
                                  <strong
                                    style={
                                      dark
                                        ? { color: "#dbdbdbff" }
                                        : { color: "#161819" }
                                    }>
                                    {goals?.away}
                                  </strong>
                                </wrap>
                              </nav>
                            </span>
                          </NavLink>
                        </div>
                      </div>
                    );
                  })}
                </section>
              </section>

              <section className="standing">
                <section className="overall">
                  {Array.isArray(standings) && standings.length > 0 ? (
                    <h1
                      style={
                        dark ? { color: "#fafafa" } : { color: "#161819" }
                      }>
                      Check Standings
                      <NavLink
                        to="standings"
                        style={{ textDecoration: "none" }}
                        className={({ isActive }) =>
                          isActive ? "active" : "navlink"
                        }>
                        {dark ? (
                          <img
                            src={whiteArrow}
                            alt=""
                            className="whitearrow to"
                            style={{
                              scale: "0.6",
                            }}
                          />
                        ) : (
                          <img
                            src={backArrow}
                            alt=""
                            className="blackarrow to"
                            style={{
                              scale: "1.2",
                              transform: "rotate(180deg)",
                            }}
                          />
                        )}
                      </NavLink>
                    </h1>
                  ) : (
                    <p></p>
                  )}

                  {Array.isArray(standings) && standings.length > 0 ? (
                    <div className="tablehead">
                      <nav>
                        <h2>POS</h2>
                        <h2>TEAM</h2>
                      </nav>

                      <span>
                        <h2>P</h2>
                        <h2>W</h2>
                        <h2>D</h2>
                        <h2>L</h2>
                        <h2>GD</h2>
                        <h2>PTS</h2>
                      </span>
                    </div>
                  ) : (
                    <></>
                  )}
                  {Array.isArray(standings) && standings.length > 0 ? (
                    standings.map((teamData, index) => (
                      <>
                        <div
                          key={teamData?.team?.id || index}
                          style={
                            dark
                              ? {
                                  color: "#fff",
                                  borderRadius: "30px",
                                  boxShadow: "1px 1px 30px rgba(0,0,0,0.39)",
                                  backgroundColor: "#333333ff",
                                }
                              : {}
                          }>
                          <nav>
                            <h2
                              style={
                                dark
                                  ? { color: "#fafafaff", marginRight: "10px" }
                                  : { color: "#3e3f3f", marginRight: "10px" }
                              }>
                              {teamData?.rank}
                            </h2>

                            <h2>
                              <img
                                src={teamData?.team?.logo}
                                width="20"
                                alt={teamData?.team?.name}
                              />

                              <span
                                className="longName"
                                style={
                                  dark
                                    ? { color: "#fafafaff" }
                                    : { color: "#3e3f3f" }
                                }>
                                {teamData?.team?.name}
                              </span>
                            </h2>
                          </nav>

                          <span
                            style={
                              dark
                                ? { color: "#fafafaff" }
                                : { color: "#3e3f3f" }
                            }>
                            <h2
                              style={
                                dark
                                  ? { color: "#fafafaff" }
                                  : { color: "#3e3f3f" }
                              }>
                              {teamData?.all?.played}
                            </h2>
                            <h2
                              style={
                                dark
                                  ? { color: "#fafafaff" }
                                  : { color: "#3e3f3f" }
                              }>
                              {teamData?.all?.win}
                            </h2>
                            <h2
                              style={
                                dark
                                  ? { color: "#fafafaff" }
                                  : { color: "#3e3f3f" }
                              }>
                              {teamData?.all?.draw}
                            </h2>
                            <h2
                              style={
                                dark
                                  ? { color: "#fafafaff" }
                                  : { color: "#3e3f3f" }
                              }>
                              {teamData?.all?.lose}
                            </h2>
                            <h2
                              style={
                                dark
                                  ? { color: "#fafafaff" }
                                  : { color: "#3e3f3f" }
                              }>
                              {teamData?.goalsDiff}
                            </h2>
                            <h2
                              style={
                                dark
                                  ? { color: "#fafafaff" }
                                  : { color: "#3e3f3f" }
                              }>
                              {teamData?.points}
                            </h2>
                          </span>
                        </div>
                      </>
                    ))
                  ) : (
                    <p></p>
                  )}
                </section>
              </section>

              <section className="players">
                {!loadingPlayers &&
                  Array.isArray(players) &&
                  players.length > 0 && (
                    <h1
                      style={
                        dark ? { color: "#fafafa" } : { color: "#161819" }
                      }>
                      Squad
                      <NavLink
                        to="squad"
                        style={{ textDecoration: "none" }}
                        className={({ isActive }) =>
                          isActive ? "active" : "navlink"
                        }>
                        {dark ? (
                          <img
                            src={whiteArrow}
                            alt=""
                            className="whitearrow to"
                            style={{
                              scale: "0.6",
                            }}
                          />
                        ) : (
                          <img
                            src={backArrow}
                            alt=""
                            className="blackarrow to"
                            style={{
                              scale: "1.2",
                              transform: "rotate(180deg)",
                            }}
                          />
                        )}
                      </NavLink>
                    </h1>
                  )}

                {loadingPlayers ? (
                  <p style={{ marginTop: "0px" }}>
                    <Skeleton dark={dark} count={6} />
                  </p>
                ) : Array.isArray(players) && players.length > 0 ? (
                  <div className="playersGrid">
                    {players.slice(0, 10).map((player, index) => (
                      <div className="playerRow" key={player?.id || index}>
                        <NavLink
                          to={`/players/${player.name
                            ?.trim()
                            .replace(/[^a-zA-Z.\s]/g, "")
                            .replace(/\s+/g, "-")
                            .toLowerCase()}-${player.id}`}
                          state={{ player }}
                          //  to={`/teams/players/${player.id}`}
                          key={player.id}>
                          <div
                            className="playerCard"
                            style={
                              dark ? { backgroundColor: "#333333ff" } : {}
                            }>
                            <img
                              src={player?.photo}
                              alt={player?.name}
                              onError={(e) => (e.target.style.display = "none")}
                            />

                            <nav>
                              <h3 style={{ color: "white" }}>
                                {player?.name || "Unknown Player"}
                              </h3>
                              <p style={{ color: "white" }}>
                                {player?.position || "Unknown Position"}
                              </p>

                              <span style={{ color: "white" }}>
                                #{player?.number ?? "-"} | Age:{" "}
                                {player?.age ?? "-"}
                              </span>
                            </nav>
                          </div>
                        </NavLink>
                      </div>
                    ))}

                    <div className="more">
                      <NavLink style={{ textDecoration: "none" }} to="squad">
                        <p>See full squad</p>
                      </NavLink>
                    </div>
                  </div>
                ) : (
                  <p style={{ padding: "10px" }}>No players available</p>
                )}
              </section>
            </>
          )}

          {activeTab === "news" && (
            <Teamnews
              dark={dark}
              loading={loading}
              error={error}
              MyBaseUrl={MyBaseUrl}
              teamId={teamId}
              myteam={myteam}
            />
          )}

          {activeTab === "standings" && (
            <Teamstanding
              dark={dark}
              loading={loading}
              error={error}
              MyBaseUrl={MyBaseUrl}
              teamId={teamId}
              myteam={myteam}
            />
          )}

          {activeTab === "matches" && (
            <Teammatch
              dark={dark}
              loading={loading}
              error={error}
              MyBaseUrl={MyBaseUrl}
              teamId={teamId}
              myteam={myteam}
            />
          )}

          {activeTab === "squad" && (
            <Teamsquad
              dark={dark}
              loading={loading}
              error={error}
              MyBaseUrl={MyBaseUrl}
              teamId={teamId}
              myteam={myteam}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default Teamdetail;
